import { render, staticRenderFns } from "./addCost.vue?vue&type=template&id=b2ba73cc&scoped=true&"
import script from "./addCost.vue?vue&type=script&lang=js&"
export * from "./addCost.vue?vue&type=script&lang=js&"
import style0 from "./addCost.vue?vue&type=style&index=0&id=b2ba73cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ba73cc",
  null
  
)

export default component.exports